import { render, staticRenderFns } from "./StringViewAndEdit.vue?vue&type=template&id=72b7541f&scoped=true"
import script from "./StringViewAndEdit.vue?vue&type=script&lang=ts"
export * from "./StringViewAndEdit.vue?vue&type=script&lang=ts"
import style0 from "./StringViewAndEdit.vue?vue&type=style&index=0&id=72b7541f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7541f",
  null
  
)

export default component.exports